import { render, staticRenderFns } from "./LogOn.vue?vue&type=template&id=edd7fd72&scoped=true&"
import script from "./LogOn.vue?vue&type=script&lang=js&"
export * from "./LogOn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edd7fd72",
  null
  
)

export default component.exports